export enum UserType {
	Registered = 'Registered',

	// Temp Users Types:
	Email = 'Email',
	Sms = 'Sms',
	Whatsapp = 'Whatsapp',
	Qr = 'Qr',
}
